import { loadOptions } from '../../versa/formset.js';
import db from '../../versa/db.js';

// Requires observer.js
export default function (...args)	// 0=selling_unit_id, 1=purchasing_unit_id
{

	let SHARED = { _this: null };

	return {

		_unit: args[0] ? 'purchasing_unit_id' : 'selling_unit_id',

		async actions(ev, publisher, value)
		{
			switch (true)
			{
				case /^#company_id/.test(publisher.selector):
					await this.loadUnits(value);
					break;
				case /^#product_id/.test(publisher.selector):
					await this.setUnit(value);
					break;
			}
		},

		async loadUnits(company_id)
		{
			const action = async (company_id) =>
			{
				let units = await db.list('units', IDBKeyRange.bound([company_id, ''], [company_id, '\uffff']));
				loadOptions(this.selector, units, 'id', ['name']);
				this.refresh();
			}
			if (typeof company_id == 'string')
				this.preventMultiCalls(SHARED, action, () => this.refresh(), company_id);
		},

		async setUnit(product_id)
		{
			if (!this.isEmpty())
				return;
			let company_id = this.locate('company_id').getValue();
			if (!company_id || company_id < 0 || !product_id || product_id < 0)
				return;
			let product = await db.get('products', [company_id, Number(product_id)]);
			if (!product)
				return;
			let unit = await db.get('units', [company_id, product[this._unit]]);
			if (!unit)
				return;
			this.setValue(unit['id']);
			this.refresh();
			this.checkErrorState();
		}

	};

}

